"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Description = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const utils_1 = require("../../utils");
function Description({ className, children, hasScroll = true, }) {
    const { i18n } = (0, i18n_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(StyledScrollView, { hasScroll: hasScroll, className: className, "data-e2e": 'Description_StyledScrollView', children: (0, utils_1.parseInfoBoxDescription)(children, i18n.language) }));
}
exports.Description = Description;
const StyledScrollView = (0, styled_components_1.default)(ui_1.ScrollView) `
  font-size: 13px;
`;
